import React from 'react'
import { CiamActiveDirectory, CiamMagicLink } from 'lib-tra-ciam-active-directory-react';
import Spinner from "react-bootstrap/Spinner";  
import KJUR from 'jsrsasign';
import { sessionStart } from '../apollo/RestServices';

let cname = "appstest.cibercolegios.com";
let apikey = "4_-h5aQUXLlveqAyDSYoGkyQ"
if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
  cname = "appsprod.cibercolegios.com";
  apikey= "4_GerVtDXv3HXv7VGBKUvu5w"
} 

const assignToken =(resp)=>{
    return new Promise((resolve)=>{
        const payLoad = {
            sub: `${resp.data.numeroDocumento}_2`,
            exp: Math.floor(Date.now() / 1000) + (60 * 60),
            customer: {
                documentNumber: resp.data.numeroDocumento,
                documentType: resp.data.tpIdentificacion,
                telephoneNumber: "NA",
                mail: resp.profile.email,
                timeSession: "60",
                username: `${resp.data.numeroDocumento}_2`,
                firstName: resp.profile.firstName,
                lastName: resp.profile.lastName,
                uid: resp.UID,
                uidSignature: resp.UIDSignature,
                signatureTimestap: resp.signatureTimestamp
            }
        }
        const sHeader = JSON.stringify({ alg: "HS256", typ: "JWT" });
        const token = KJUR.jws.JWS.sign("HS256", sHeader, payLoad, { utf8:  resp.data.numeroDocumento });
        sessionStorage.setItem("auth_token", token);
        sessionStart(token).then(_=>{
            resolve();
        });
    });
}


export class SsoSignInForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }
    componentDidMount() {
        
        this.setState({
            loading:true
        })
        
        setTimeout(() => {
            this.setState({
                loading:false
            });
        }, "2000");
    }

    render() {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const redirectionPath = urlParams.get('returnUrl');
        let title = "Ingreso a Cibercolegios"
        if(!redirectionPath.includes("bridge")){
            title = "Inscripción a Cibercolegios"
        }


        return (<div className="card card-signin my-5 col-sm-6 border-left-0">

            <div className="card-body">
                <h1 className="card-title text-center">{title}</h1>
                <div className="form-signin">
                <center>
                    {this.state.loading?<Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                    </Spinner>:null}
                </center>   
                <CiamActiveDirectory

                    apiKey={apikey}
                    btnClass='btn btn-lg btn-primary btn-block'
                    contentClass='form-signin'
                    redirectLogin={redirectionPath}
                    btnEditProfile={false}
                    btnRegisterLite={false}
                    cdn={cname}
                    autoopen={true}                    
                    btnRegister={false}
                    loginCallBack={assignToken} />
                    
                </div>
            </div>
        </div>)
    }
}

export class MagicLinkRedirection extends React.Component {

    render() {
       let spinners = [];
       for (let i = 0; i < 20; i++) {
         spinners.push(<Spinner animation="grow" className="align-item-center"/>)
       }
       return (
         <div className="card card-signin my-5 col-sm-12 border-left-0 " style={{background: "#003A72"}}>
           <img alt="colsubsidio" className="justify-content-center align-self-center"
             style={{maxWidth: "300px", paddingTop: "10%"}}
             src="https://cmscolsubsitio.netactica.net/Portals/1107/logo.png?ver=2019-05-16-125847-977"/>.
           <h2 className="card-title row justify-content-center align-self-center text-white">Cargando</h2>
           <div className="card-body d-flex align-self-center">
             {spinners}
             <CiamMagicLink magicCallBack={assignToken}></CiamMagicLink>
           </div>
         </div>)

    }
}


